export enum ProductNames {
	RKO = 'rko',
	RBO = 'rbo',
}
